import { CreateMetadataModeFormValue } from '~bank-contacts/types/forms'

export interface CreateModeSelectDialogProps {
  isOpen: boolean
  onClose: () => void
  onSubmit: (value: CreateMetadataModeFormValue) => void
}
